let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("izlIU")).then(() => parcelRequire('gH2R4'));